import { Descriptions, Tag } from 'antd';
import { formatDateTime } from 'utils/formatDate';

const STATUS_MAP = {
  1001: { label: 'Open', color: 'green' },
  1002: { label: 'Close', color: 'blue' },
};

const ItemDetail = ({ item }) => {
  const status = STATUS_MAP[item.status] || {
    label: item.status,
    color: 'default',
  };

  return (
    <Descriptions column={1} bordered>
      <Descriptions.Item label="ID">{item.id}</Descriptions.Item>
      <Descriptions.Item label="Date">{item.date}</Descriptions.Item>
      <Descriptions.Item label="Status">
        <Tag color={status.color}>{status.label}</Tag>
      </Descriptions.Item>
      <Descriptions.Item label="Description">
        {item.description}
      </Descriptions.Item>
      <Descriptions.Item label="Created At">
        {formatDateTime(item.created_at)}
      </Descriptions.Item>
      <Descriptions.Item label="Updated At">
        {formatDateTime(item.updated_at)}
      </Descriptions.Item>
    </Descriptions>
  );
};

export default ItemDetail;
